import styled from "styled-components";

export const AttachmentSpinnerWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
`;

export const AttachmentImage = styled.img`
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    display: block;
`;

export const AttachmentPdfWrapper = styled.div`
    width: 100%;
    height: 100%;
    min-height: 0;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    > *
    {
        width: 100%;
        height: 100%;
        max-height: 100%;
    }
`;

export const AttachmentPdfFrame = styled.iframe`
    width: 100%;
    height: 100%;
    border: 0;
    display: block;
`;

export const AttachmentLink = styled.a`
    display: block;
    width: 100%;
    height: 100%;
`;